import { useCallback } from 'react';
import { applyNodeChanges } from 'react-flow-renderer';

const useSafeNodesChange = (setNodes) => {
    return useCallback((changes) => {
        const filtered = changes.filter((change) => change.type !== 'dimensions');

        if (filtered.length > 0) {
            setNodes((nds) => applyNodeChanges(filtered, nds));
        }
    }, [setNodes]);
};

export default useSafeNodesChange;
